// Domain to username mapping
export const DOMAIN_USERNAME_MAP = {
  localhost: "stuart",
  "stuartlogan.com": "stuart",
  "twine.tobynutter.co.uk": "TobyNutter",
  "zotoromusic.com": "zachkester3",
  "diima.site": "diima",
  "twine.projectmachine.net": "ZiadMalik",
};
